// @greenlight-spec: 19-design-system.md
// A small pulsing green dot + label, used to signal a live/streaming surface
// (the audit feed, the audit-log table). Extracted so /audit's two live
// indicators share one implementation. Color is paired with text, never alone.
import * as React from 'react';

export function LiveIndicator({ label = 'Live' }: { readonly label?: string }) {
  return (
    <span className="flex items-center gap-2 text-[12px] font-medium text-[hsl(var(--status-green-text))]">
      <span className="relative inline-flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--status-green))] opacity-50 motion-safe:animate-ping" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-[hsl(var(--status-green))]" />
      </span>
      {label}
    </span>
  );
}
